export const environment = {
  production: true,
  wsEndpoint: 'wss://broker.ubiwan.net',
  apiBaseUrl: 'https://api-fleet.moncoyote.com/',
  apiVersion: 'v53',
  reconnectInterval: 2000,
  mapboxToken: 'pk.eyJ1IjoidWJpd2FuIiwiYSI6ImNtaTV6dHV4cDFjbDcybHF2ODhqYmNycmEifQ.HVqh31S2cXVPjAbGcop-uQ',
  posthogKey: 'phc_QC4pxaieO2XjEVSa11H6y2GxbuCxJ8Ma9FTS0smuA0s',
  posthogHost: 'https://eu.i.posthog.com',
};
